import script from "./cashWheelView.vue?vue&type=script&setup=true&lang=ts"
export * from "./cashWheelView.vue?vue&type=script&setup=true&lang=ts"

import "./cashWheelView.vue?vue&type=style&index=0&id=7b6d607b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6d607b"]])

export default __exports__